@if (html$ | async; as html) {
  <div [innerHtml]="html"></div>
}
